import {Inject, Injectable, InjectionToken} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, finalize, timeout} from 'rxjs/operators';
import {LoadingService} from "./loading.service";
import {UtilsService} from '../utils/utils.service';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number,
              public loadingSvc: LoadingService, public utils: UtilsService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingSvc.announceLoading(true);
    const timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue) * 10000; // Le timeout passé est exprimé en secondes, le timeout de rxjs attend des ms
    return next.handle(req).pipe(timeout(timeoutValueNumeric),
      catchError(error => this.utils.handleError(error, true)),
      finalize(() => this.loadingSvc.announceLoading(false))
    );
  }
}
